<template>
  <div class="dialogGroup_cont">
    <div
      class="dialogGroup_left no_group"
      :class="groupLeftEventNone?'eventNone':''"
      :style="'overflow: hidden;'+ (treeMenuShow!=true?'width:60px':'') + (groupLeftEventNone?'opacity: 0.5;':'')"
    >
      <el-tooltip
        v-model="treeMenuShowTip"
        class="item"
        effect="dark"
        :content="$t('tree.treeMenuShowTip')"
        placement="top"
      >
        <img
          style="position: absolute;top: 16px;left: 16px;font-size: 20px;cursor: pointer;z-index: 1;"
          src="../../assets/img/caidanicon.png"
          @click="treeMenuShow = !treeMenuShow"
        >
      </el-tooltip>
      <ly-tree
        v-show="treeMenuShow"
        ref="lyTree"
        :gpno="areaid"
        :post-fun-param="postFunParamTree"
        :is_superuser="false"
        :area-tree-type="areaTreeType"
        :execute-type="executeType"
        :exend-protocol-types="exendProtocolTypes"
        :showcount="showcount"
        :displaynoarea="displaynoarea"
        :onlynoarea="isreplace"
        :style="!is_group?'bottom:200px':''"
        :is_switch="isSwitch"
        :sideflex="true"
        @treeClick="treeClick"
        @switchClick="switchClick"
        @getCheckedKeys="getCheckedKeys"
        @sideflexEvent="sideflexEvent"
      />
      <div
        v-if="!is_group && !hideTree"
        v-show="treeMenuShow"
        class="tree_group"
        style="height:200px"
      >
        <div class="blue_header">
          <span>{{ $t('deviceChoose.groupsingle') }}</span>
        </div>
        <div class="edit_group_box">
          <vuescroll>
            <div
              v-for="(items, indexs) in groups"
              :key="indexs"
            >
              <div
                class="add_group animated  fadeInLeft"
                @click="groupsShown(items)"
              >
                <div class="edit_group">
                  <span
                    class="course_block"
                    :title="items.Name + ' ('+items.group.length +')'"
                  >{{ items.Name }} {{ '('+items.group.length +')' }}</span>
                  <!-- <div>
                    <span class="course_block">{{ items.Name }}</span>
                    <span style="right: 0;">{{'('+items.group.length +')'}}</span>
                  </div> -->
                </div>
              </div>
              <template v-if="items.shown == true">
                <vuescroll style="margin-left:20px;">
                  <div
                    v-for="(item, index) in items.group"
                    :key="index"
                    class="add_group animated  fadeInLeft"
                  >
                    <div class="edit_group">
                      <span
                        v-if="item.edit_group"
                        class="edit_group_span"
                        :title="item.Name"
                      >{{ item.Name }} {{ item.DeviceInfos == null ? '': '('+item.DeviceInfos.length+')' }}</span>
                      <input
                        v-else
                        v-model="item.Name"
                        style="background: transparent;"
                        @keyup.enter="doUpdateName(item,indexs,index)"
                      >
                    </div>
                    <div
                      class="groupchecked"
                      :style="item.selected?`background-image: url(${require('@static/img/checkboxYes.png')});`:''"
                      @click.stop="getvidsort(item)"
                    />
                    <i
                      class="icon--1 edit"
                      @click="delgroup(item,indexs,index)"
                    />
                    <i
                      class="icon-1 edit"
                      @click="editGroupName(item,indexs,index)"
                    />
                  </div>
                </vuescroll>
              </template>
            </div>
          </vuescroll>
        </div>
      </div>
    </div>
    <div
      class="dialogGroup_right"
      :class="treeMenuShow != true ? 'slidexport':''"
      :style="groupRightEventNone?'background-color: rgba(255, 255, 255, 0.5);':''"
    >
      <div
        v-show="treeMenuShow != true"
        class="slidPoint"
      >
        {{ multipleAreaSelectedTopArea["name"] }}
      </div>
      <div
        class="Group_right_header"
        :style="treeMenuShow != true?'margin-top: 0px;':''"
      >
        <div
          class="blue_header"
          style="line-height: 37px;"
        >
          <span>
            {{ $t('deviceChoose.devicestotal') }}
            <!-- <template v-if="!is_group"> -->
            <!-- （ -->
            <em style="min-width: 40px;display: inline-block;">{{ getCardTolal() }}</em>
            <!-- ） -->
            <!-- </template>
            <template v-else>{{allcardNum}}</template> -->
          </span>
        </div>
        <!-- <el-select class="cssHeight25"
          :class="groupRightEventNone?'eventNone':''"
          :style=" 'width:auto;' + (groupRightEventNone?'opacity: 0.5;':'')"
					@change="skusiftsortEvent"
					v-model="skuSiftValue"
					multiple
					collapse-tags
					:placeholder="$t('install.choose')"
				>
					<el-option v-for="item in skuSiftOptions" :key="item.ClassSku" :label="item.ClassSkuName" :value="item.ClassSku"></el-option>
				</el-select> -->

        <!-- <div class="select_but" :class="groupRightEventNone?'eventNone':''" :style="'display: inline-flex;margin: 0 5px;' + (groupRightEventNone?'opacity: 0.5;':'')" v-if="!is_group">
          <button v-if="getCardTolal() == checckdata.length" class="button_light" style="margin:0 7.5px;float: left;margin-top: 7px;" @click="checkAll(false)">{{ $t('scene.all') }}</button>
          <button v-else class="button_light" style="margin:0 7.5px;float: left;margin-top: 7px;" @click="checkAll(true)">{{ $t('scene.allno') }}</button>
        </div> -->
        <sort-select
          v-if="!hideTree"
          :value="sortType"
          @change="sortTypeChange"
        />
        <el-popover
          v-if="!hideTree"
          :class="groupRightEventNone?'eventNone':''"
          placement="bottom"
          trigger="click"
          style="position: relative;bottom: -5px;"
        >
          <div class="optionObj-height">
            <div
              v-for="(optionObj, index) in skuSiftOptions"
              :key="index"
              :style="'display: flex;' + ((index+1)<skuSiftOptions.length?'margin-bottom: 10px;padding-bottom: 10px;border-bottom: solid 1px rgb(204 204 204 / 0.3);':'')"
            >
              <div>
                <el-checkbox
                  v-model="optionObj['checked']"
                  @change="skusiftsortEvent('skuSiftValue')"
                >
                  {{ optionObj["ClassSkuName"] }}
                </el-checkbox>
              </div>
            </div>
          </div>
          <el-button
            slot="reference"
            style="border:none;background: transparent;padding: 0;"
          >
            <div
              class="fl-center"
              style="width: max-content;margin: 0 5px;cursor: pointer;"
            >
              <img
                src="../../assets/img/deviceFilter.png"
                style="margin: 0 5px;"
              ><span>{{ $t("install.deviceFilter") }}</span>
              <i class="el-select__caret el-input__icon el-icon-arrow-down" />
            </div>
          </el-button>
        </el-popover>
        <div
          v-if="!hideTree"
          class="search_way"
          :class="groupRightEventNone?'eventNone':''"
          style="width: 20%;float: none;margin: 0;"
        >
          <el-input
            v-model="searchKeywords"
            :placeholder="$t('sylogs.plhode3')"
            size="medium"
            style="height: 30px;line-height: 30px;"
            @keyup.enter.native="skusiftsortEvent"
          />
          <el-button
            type="text"
            style="position: absolute;right: 0px;top: 0px;"
            icon="el-icon-search"
            @click="doSkusiftsortEvent()"
          />
          <!-- <el-checkbox v-model="isSearchKeywords" style="position: absolute;right: 0px;top: 8px;" @change="skusiftsortEvent('skuSiftValue')">
            <i class="el-icon-search"></i>
          </el-checkbox> -->
        </div>

        <div
          v-if="isVisual"
          :title="$t('deviceChoose.chooseDeviceInMap')"
          class="button-light"
          @click="chooseDeviceInMap"
        >
          {{ $t('deviceChoose.chooseDeviceInMap') }}
        </div>

        <!-- <template v-if="isGroupSaveBar">
          <div class="create_group" :class="groupRightEventNone?'eventNone':''" v-if="!is_group" :style="'position: relative;margin: 0px 5px;width: auto;' + (groupRightEventNone?'opacity: 0.5;':'')">
            <el-checkbox v-model="groupchecked" :title="multipleAreaSelectedTopArea['name']" style="margin-right: 2px;">{{ $t('deviceChoose.group') }}:</el-checkbox>
            <input v-model="groupname" :placeholder="$t('deviceChoose.groupwarning')" style="background: transparent;width: 130px;margin-right: 2px;"/>
            <el-button style="height: 25px;line-height: 25px;bottom: 5px;padding: 0 5px;width: max-content;" @click="saveGroup" v-loading="grouploading">{{ $t('deviceChoose.save') }}</el-button>
          </div>
        </template> -->
        <template v-if="isShowAreaLimit">
          <template v-if="isGroupControlBar">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-checkbox
              v-model="groupControlValue"
              :class="(isOccupiedLimitGroup == true && isDataOccupiedLimitGroup == true)?'eventNone':''"
              @change="$event => groupControlEvent($event)"
            >
              {{ groupControlName }}
            </el-checkbox>
            <el-tooltip
              :content="$t('hcl.warning7')"
              placement="bottom"
              effect="light"
            >
              <i class="el-icon-info" />
            </el-tooltip>
          </template>
        </template>
        <div
          class="ok_group de_ok_group"
          style="margin-top: 0px;"
        >
          <div
            v-if="isDeviceForceRadio === undefined ? !is_group : !isDeviceForceRadio"
            class="select_but"
            :class="groupRightEventNone?'eventNone':''"
            :style="'display: inline-flex;margin: 0 5px;' + (groupRightEventNone?'opacity: 0.5;':'')"
          >
            <el-checkbox
              v-model="select"
              @change="checkAll"
            >
              {{ select?$t('scene.all'):$t('scene.allno') }}
            </el-checkbox>
          </div>
          <template v-if="isGroupSaveBar ">
            <el-button
              v-if="!is_group && !hideTree"
              type="text"
              class="button_light"
              :class="(groupRightEventNone || checckdata.length<1)?'eventNone':''"
              :style="'background: #FEFEFE;border: 1px solid #0046AA;font-weight: 500;color: #0046AA !important;'+ ((groupRightEventNone || checckdata.length<1)?'opacity: 0.5;border-color: #a8a8a8!important;color: #a8a8a8!important;':'')"
              :title="multipleAreaSelectedTopArea['name']"
              @click="createGroup"
            >
              {{ $t('deviceChoose.group') }}
            </el-button>
          </template>
          <slot name="next-step" />
          <template v-if="!is_group">
            <el-badge
              :value="checckdata.length"
              class="item"
            >
              <button @click="createGrop">
                {{ confirmName || $t('deviceChoose.sure') }}
              </button>
            </el-badge>
          </template>
          <template v-else>
            <button @click="createGrop">
              {{ confirmName || $t('deviceChoose.sure') }}
            </button>
          </template>
        </div>
      </div>

      <div
        class="Group_right_header"
        style="margin-top: 5px;padding: 0 15px;"
      >
        <div
          v-if="skuSiftValue.length>0"
          :style="'width:100%;height:50%;justify-content: left;overflow: auto;'"
          class="fl-center"
        >
          <span
            v-if="skuSiftValue.length>2"
            class="filter-button filter-span"
            @click="skuSiftValueClaer"
          >{{ $t('base.resetFilter') }}</span>
          <el-tag
            v-for="(tag,index) in skuSiftValue"
            :key="index"
            style="margin-right: 10px;"
            closable
            type="info"
            @close="tag['checked'] = false; skuSiftValue.splice(index,1);skusiftsortEvent('skuSiftOptions');"
          >
            {{ tag['ClassSkuName'] }}
          </el-tag>
        </div>
      </div>
      <OppleDeviceTableModal
        :visible="isDeviceTableModalVisible"
        :title="$t('iftttset.isOccupied').replace(/\$\$/, groupControlTitleName || '')"
        :device-list="occupiedList"
        :text="$t('limite.ok')"
        @close="isDeviceTableModalVisible = false"
      />
      <div
        ref="video_area"
        v-loading="loading"
        class="right_card_box fox"
        :class="groupRightEventNone?'eventNone':''"
        :style="(groupRightEventNone?'opacity: 0.5;':'')"
      >
        <vuescroll>
          <el-row :gutter="0">
            <div
              ref="video_area_context"
              v-infinite-scroll="loadMore"
              :style="{height:videoHeight}"
              style="overflow:auto"
              infinite-scroll-disabled="isdropdown"
              infinite-scroll-distance="30"
              @scroll="scrollEvent"
            >
              <v-card
                v-if="isNeedSameDeviceStatus === 0 || !loading"
                :register-list="registerList"
                :is-scroll-regist="isScrollRegist"
                :pageindex="pageIndex"
                :cardlist="card_list2"
                :is_check="true"
                :required-max-device="requiredMaxDevice"
                :max-device="maxDevice"
                :has-select-device="hasSelectDevice"
                :isradio="isDeviceForceRadio === undefined ? is_group : isDeviceForceRadio"
                @removeTree="removeTree"
              />
              <div
                v-loading="dropdownloading"
                class="bottom_loader"
                :element-loading-text="$t('install.loading')"
                element-loading-spinner="el-icon-loading"
              />
            </div>
          </el-row>
        </vuescroll>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable no-lonely-if -->
<!-- eslint-disable vue/prop-name-casing -->
<script>
import vuescroll from 'vuescroll';
import vCard from '@/components/common/cardtwoSmall.vue';
import { ChooseActionDeviceListIlluminat } from '@/axios/IConstIllumination.js';
import { ChooseActionDeviceListRhythm } from '@/axios/IRhythm.js';
import { GetCanBindListByPage, FindSimpleDeviceListByPage, FindSummaryDeviceListByPage } from '@/axios/IDevice.js';
import { Post, UpdateName, Delete, Get, GetList } from '@/axios/ITemporaryGroup.js';
import { ChooseHCLDeviceList } from '@/axios/IHcl.js';
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';
import SortSelect from "@/components/select/SortSelect";
import { getSortType, debounce } from "@utils/utils";
import OppleDeviceTableModal from '@/components/OppleDeviceTableModal';

export default {
  components: {
    vuescroll,
    vCard: () => import('@/components/common/cardtwoSmall.vue'),
    SortSelect,
    OppleDeviceTableModal
  },
  props: {
    pageType: {
      type: String,
      default: ''
    },
    isIfttt: {
      type: Boolean,
      default: false
    },
    isDeviceForceRadio: {
      type: Boolean,
      default: undefined
    },
    is_group: {
      type: Boolean,
      default: true
    },
    showcount: {
      type: Boolean,
      default: true
    },
    searchtype: {
      type: Number,
      default: 1
    },
    areaid: {
      type: Number,
      default: -1
    },
    areaTreeType: {
      type: Number,
      default: 1
    },
    executeType: {
      type: Number,
      default: 0
    },
    exendProtocolTypes: {
      type: Number,
      default: null
    },
    displaynoarea: {
      type: Boolean,
      default: false
    },
    isreplace: {
      type: Boolean,
      default: false
    },
    checkeddata: {
      type: Array,
      default() {
        return [];
      }
    },
    triggledevice: {
      type: Boolean,
      default: false
    },
    actionedevice: {
      type: Boolean,
      default: false
    },
    ispannel: {
      type: Boolean,
      default: false
    },
    isCompare: {
      type: Boolean,
      default: false
    },
    postFunParam: {
      type: Object,
      default: null
    },
    confirmName: {
      type: String,
      default: null
    },
    isShowCheck: {
      type: Boolean,
      default: false
    },
    isGroupSaveBar: {
      type: Boolean,
      default: true
    },
    isGroupControlBar: {
      type: Boolean,
      default: false
    },
    groupControlTitleName: {
      type: String,
      default: ''
    },
    groupControlName: {
      type: String,
      default: ''
    },
    isConfirmcCalibrate: {
      type: Boolean,
      default: true
    },
    // postFun:{
    //   type: Function,
    // 	default: null
    // },
    isIlluminance: {
      type: Boolean,
      default: false
    },
    isRhythm: {
      type: Boolean,
      default: false
    },
    isHcl: {
      type: Boolean,
      default: false
    },
    isOccupied: {
      type: Boolean,
      default: false
    },
    isOccupiedLimitGroup: {
      type: Boolean,
      default: false
    },
    curRuleId: {//当前规则ID
      type: Number,
      default: null
    },
    isCurRuleGroup: {//修改当前规则（是否组控）
      type: Boolean,
      default: false
    },
    postFunParamTree: {
      type: Object,
      default: null
    },
    childCategoryType: {
      type: [String, Number],
      default: () => '',
    },
    isSence:{
      type:Boolean,
      default:false
    },
    // 是否隐藏区控控件
    isHiddenAreaLimit: {
      type:Boolean,

      default:false
    },
    classSkus: {
      type: String,

      default: ''
    },
    deviceCategoryType: {
      type: [String, Number],
      default: null
    },
    isNeedSameDeviceStatus: {
      type: Number,
      default: 0,
    },
    //isreplace 是否替换
    /** 网关id, 用来查询特定网关下的设备 */
    gatewayVDeviceId: {
      type: String,
      default: ''
    },
    onlyClassSku: {
      type: Array,
      default:()=>{
        return []
      },
    },
    executeClassSku: {
      type: Array,
      default:()=>{
        return []
      },
    },
    requiredMessageType: {
      type: String,
      default: null
    },
    getDeviceListFn: {
      type: Function,
      default: null
    },
    isVisual: {
      type: Boolean,
      default: false
    },
    // 自动化选中设备不过滤,并且卡片标上已选状态
    multipleDialogGroup:{
      type: Boolean,
      default: false
    },
    onlyCompareDevice: {
      type: Boolean,
      default: false
    },
    //是否支持最大设备选择
    requiredMaxDevice: {
      type: Boolean,
      default:false
    },
    //最多选择几个设备
    maxDevice: {
      type: Number,
      default: 0
    },
    //已经选择了几个设备
    hasSelectDevice: {
      type: Number,
      default: 0
    },
     //是否隐藏tree
     hideTree:{
      type:Boolean,
      default:false
    },
    //单选也要注册
    singleChoiceRegister: {
      type: Boolean,
      default: false
    },
     // 是否真实设备 -1-全部 0-虚拟设备 1-真实设备
     bindStatus:{
      type: Number,
      default: -1
    },
    //根据这个判断是新建还是编辑，编辑模式直接跳到步骤2，不执行步骤1
    constantid: {
      type: Number,
      default: -1
    },
    is_groupControlDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    console.log('.....hideTree',this.hideTree)
    return {
      isDataOccupiedLimitGroupDisabled: false,
      sortType: getSortType(),
      dropdownloading: false, //控制是否下拉刷新
      videoHeight: 0, //滑动区域高度
      isshow: false, //组件刷新
      grouploading: false, //群组提交的load
      groupname: '', //群组名称
      isdropdown: true, //默认禁用下拉
      loading: false, //是否加载
      pageIndex: 1, //当前页
      pageSize: this.$store.state.pageTotalLimit, //每页显示数量
      allcardNum: 0, //数量
      groupchecked: true, //是否选中
      groups: [], //区域的分组集合群
      card_list2: [], //设备集合
      card_list2Source: null,//当前所注入的区域设备集
      checckdata: [], //选中的对象集合
      groupchecckdata: [], //群组选中的对象集合
      gpno: -1, //点击的树形id
      alreadychecked: [], //已选中的设备排除
      select: false, // 全选按钮
      scrollEventTime: null,
      scrollEventFunParam: null,
      registerList: [], //注册的设备集合
      isScrollRegist: false, //是否已滚动
      areamodel: [],//待选池内的区域设备集合
      areaSelectedModel: [],//区域树上已勾选的区域ID集合
      isSwitch: true,//树节点多勾选能力
      multipleAreaSelectedTopArea: { gpno: this.areaid, name: '', isOverstep: false },//当前多区域勾选最顶层区域（用于群组保存 归属）
      curHalfCheckedArea: null,
      treeMenuShowTip: false,
      treeMenuShow: true,//左边功能区域显示
      skuSiftOptions: [],//sku筛选下拉框
      skuSiftValue: [],////sku筛选值
      groupLeftEventNone: false,
      groupRightEventNone: false,
      groupControlValue: false,
      groupControlValueDisabled: false,
      postFunction: FindSimpleDeviceListByPage,
      isDataOccupiedLimitGroup: false,
      RecordList: null,
      optionArryValue: [],
      searchKeywords: '', //搜索关键字-用于搜索
      isSearchKeywords: false, //搜索关键字-是否勾选
      showTips: false, //  是否提示过
      gpNos: null,
      isDeviceTableModalVisible: false,
      occupiedList: [],
    };
  },
  computed: {
    // 是否展示区控
    isShowAreaLimit() {
      return (
        !this.isOccupiedLimitGroup ||
        !this.isDataOccupiedLimitGroup
      ) && !this.isHiddenAreaLimit
    },

    // occupiedListInfo() {
    //   return `[${this.occupiedList.map(item => item.DeviceName).join('、')}] 已被设置了恒照度, 无法选择群控`
    // }
  },
  mounted() {
    if (this.isIlluminance) { this.postFunction = ChooseActionDeviceListIlluminat; }
    else if (this.isRhythm) { this.postFunction = ChooseActionDeviceListRhythm; }
    else if (this.isHcl) { this.postFunction = ChooseHCLDeviceList }
    else if (this.isSence) { this.postFunction = FindSummaryDeviceListByPage }

    const fn = this.postFunction.bind(this);
    this.postFunction = (para, callBack) => {
      para.sortMode = this.sortType;
      return fn(para, callBack);
    }

    this.debounceMessage = debounce((message) => {
      this.$message({
        type: 'warning',
        message
      })
    }, 300),

    this.refresh();
  }, //is_group(true单选 false复选) searchtype(1真实网关 0虚拟网关 ...只对设备选择生效) areaid区域id  areaTreeType1设备2场景3自动化 displaynoarea是否隐藏无区域   checkeddata已选中的对象 triggledevice是否选择triggle设备 actionedevice是否选择action设备ispannel是否选择面板
  methods: {
    groupControlEvent($event) {
      if (this.isDataOccupiedLimitGroupDisabled) {
        this.groupControlValue = false;
        this.isDeviceTableModalVisible = true;
        return
      }
       this.$emit('groupControlEvent', $event);
    },
    chooseDeviceInMap(){
      console.log(this.checckdata)
      this.$emit('chooseDeviceInMap',this.checckdata,this.alreadychecked);
    },
    doSkusiftsortEvent() {
      this.isSearchKeywords = true
      this.skusiftsortEvent('skuSiftValue')
    },
    sortTypeChange(v) {
      this.sortType = v;
      this.pageIndex = 1;
      this.doFindDeviceListByPage();
    },
    createGroup() {
      this.$prompt(this.$t('deviceChoose.group'), this.multipleAreaSelectedTopArea['name'], {
        confirmButtonText: this.$t('base.sure'),
        cancelButtonText: this.$t('base.cancel'),
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputPattern: /^([ 0-9 a-z A-Z ^\u4E00-\u9FA5])+$/,
        inputErrorMessage: this.$t('base.noEmpty')
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: this.$t("base.applyFor") + ' - ' + this.multipleAreaSelectedTopArea['name'] + this.$t('deviceChoose.group') + ': ' + value
        });
        this.groupname = value;
        this.saveGroup();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('base.cancel') + ' ' + this.$t('deviceChoose.group')
        });
      });
    },
    skuSiftValueClaer() {
      this.skuSiftValue.forEach(item => {
        item['checked'] = false;
      });
      this.skuSiftValue = [];
    },
    setGroupControlValue(of) {
      this.groupControlValue = of;
    },
    groupEventNone(of) {
      this.groupLeftEventNone = of;
      this.groupRightEventNone = of;
    },
    resetOccupiedLimitGroupState() {
      this.isDataOccupiedLimitGroupDisabled = false;
      this.isDataOccupiedLimitGroup = false;
      this.occupiedList = [];
    },
    async refresh() {
      //初始化页面数据
      this.resetOccupiedLimitGroupState();
      this.isSwitch = !this.is_group;
      this.card_list2 = [];
      this.card_list2Source = null;
      this.areamodel = [];
      this.groups = [];
      this.gpno = this.areaid;
      this.areaSelectedModel = [this.gpno];
      this.alreadychecked = this.checkeddata;
      await this.doFindDeviceListByPage(); //默认显示全部
      console.log('.........初始化')
      this.doGetList();
      this.getVideoHeight();

      if (this.$store.state.areasGpName[this.multipleAreaSelectedTopArea["gpno"]] != null) {
        this.multipleAreaSelectedTopArea["name"] = this.$store.state.areasGpName[this.multipleAreaSelectedTopArea["gpno"]]["GpName"];
      }

      setTimeout(() => {
        if (
          this.checkeddata &&
          this.checkeddata[0] &&
          this.isNeedSameDeviceStatus === 1
        ) {
          this.card_list2 = this.getSameDevice(this.card_list2.map(item => ({
            ...item,
            ischecked: this.checkeddata.some(
              checked => checked.VDeviceId === item.VDeviceId && checked.ChildId === item.ChildId
            )
          })))
        }
      })
    },
    sideflexEvent(param) {
      this.treeMenuShow = !this.treeMenuShow;
    },
    /**
     * 新增-区域树上指定的区域ID集合
     */
    addAreaSelectedModel(_gpno) {

      if (this.areaSelectedModel.indexOf(_gpno) < 0) { this.areaSelectedModel.push(_gpno); }
    },
    /**
     * 新增-区域树上指定的区域ID集合
     */
    delAreaSelectedModel(_gpno) {
      var _index = this.areaSelectedModel.indexOf(_gpno);
      if (_index >= 0) { this.areaSelectedModel.splice(_index, 1); }
      _index = null;
    },
    /* 获得滚动区域高度
    */
    getVideoHeight() {
      console.log('getVideoHeight');

      if (this.$refs.video_area != null) {
        this.videoHeight = this.$refs.video_area.offsetHeight - 2 + 'px';
        this.$set(this, "videoHeight", this.$refs.video_area.offsetHeight - 2 + 'px');
        // console.log('videoHeight = ' + this.videoHeight)
      }
    },
    /* 点击保存分组
    */
    saveGroup() {
      if (this.groupchecked) {
        if (this.groupname != '') {
          if (this.checckdata.length > 0) {
            if (this.multipleAreaSelectedTopArea["isOverstep"] == true) {
              this.$confirm(this.$t('deviceChoose.overStepDeviceGroupTip') + " " + this.multipleAreaSelectedTopArea["name"], this.$t('deviceMsg.prompt'), {
                confirmButtonText: this.$t('deviceMsg.save'),
                cancelButtonText: this.$t('deviceMsg.cancle'),
                type: 'warning'
              })
                .then(() => {
                  this.doPost();
                })
                .catch(() => { });
            } else {
              this.doPost();
            }
          } else {
            warning(this, this.$t('deviceChoose.checkwarning'));
          }
        } else {
          warning(this, this.$t('deviceChoose.groupwarning'));
        }
      } else {
        warning(this, this.$t('deviceChoose.checkgroupwarning'));
      }
    },
    /* 获取分组 接口返回数据处理
    * rs:接口返回原始数据包
    */
    functionDoGetList(rs, param) {
      // this.group = [];
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          var items = this.groups.find(item => {
            return param.areaNo == item.gpNo;
          });
          if (items == null) {
            items = { gpNo: param.areaNo, Name: this.$store.state.areasGpName[param.areaNo]["GpName"], group: rs.Result };
            this.groups.push(items);
            items["group"].forEach(item => {
              item.edit_group = true;
            });
          } else {
            var _item;
            rs.Result.forEach(item => {
              _item = items["group"].find(itemparam => {
                return itemparam.Id == item.Id;
              });
              if (_item != null) {
                item.selected = _item.selected;
                item.edit_group = _item.edit_group;
              } else {
                item.selected = false;
                item.edit_group = true;
              }
            });
            items["group"] = rs.Result;
          }
          items = null;
        }
      }
    },
    isJsonDeviceInfo(item) {
      if (item != null && typeof item == "string") {
        return JSON.parse(item) instanceof Array;
      }
      return flase;
    },
    functionDoGetLists(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null && rs.Result instanceof Array) {
          var items, _curJson;
          rs.Result.forEach(param => {


            items = this.groups.find(item => {
              return param.GpNo == item.gpNo;
            });
            if (items == null) {
              items = { gpNo: param.GpNo, Name: param.GpName, group: param.TemporaryGroupList };
              items["group"].forEach(item => {
                item.edit_group = true;
              });
              this.groups.push(items);
            } else {
              items["Name"] = param.GpName; //this.$store.state.areasGpName[param.areaNo];
              // items["group"] = param.TemporaryGroupList;
              var _item;
              param.TemporaryGroupList.forEach(item => {
                _item = items["group"].find(itemparam => {
                  return itemparam.Id == item.Id;
                });
                if (_item != null) {
                  // item.selected = _item.selected;
                  // item.edit_group = _item.edit_group;
                  _item["Name"] = item["Name"];
                } else {
                  item.selected = false;
                  item.edit_group = true;
                  items["group"].push(item);
                }
              });
            }

            if (param.TemporaryGroupList instanceof Array) {
              param.TemporaryGroupList.forEach(temporaryGroup => {

                if (temporaryGroup != null && temporaryGroup["DeviceInfos"] != null) {
                  _curJson = temporaryGroup["DeviceInfos"];
                  if (_curJson == null || _curJson == '') {
                    temporaryGroup["DeviceInfos"] = [];
                  } else if (_curJson.indexOf('{') >= 0 && _curJson.indexOf('}') >= 0) {
                      _curJson = JSON.parse(temporaryGroup["DeviceInfos"]);
                      if (_curJson instanceof Array) {
                        temporaryGroup["DeviceInfos"] = _curJson;
                      } else {
                        temporaryGroup["DeviceInfos"] = [_curJson];
                      }
                    } else if (_curJson.indexOf(',') > 0) {
                        temporaryGroup["DeviceInfos"] = []
                        _curJson = _curJson.split(',');
                        _curJson.forEach(param => {
                          temporaryGroup["DeviceInfos"].push({ "VDeviceId": param });
                        });
                      } else {
                        temporaryGroup["DeviceInfos"] = [{ "VDeviceId": _curJson }];
                      }
                }
              });
            }

          });

          items = null;
        }
      }
    },
    /* 修改分组名称 接口返回数据处理
    * rs:接口返回原始数据包
    */
    functionDoUpdateName(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 修改分组名称
    * item:组对象
    */
    doUpdateName(item, indexs, index) {
      //修改名称

      item.edit_group = true;
      this.groups[indexs]["group"][index] = item;
      var para = {
        ProjectCode: item.ProjectCode,
        GpNo: item.GpNo,
        Name: item.Name
      };
      UpdateName(para, this.functionDoUpdateName);
      para = null;
    },
    /* 分组元素展示伸缩
    * model:分组对象
    */
    groupsShown(model) {
      if (model["shown"] != null) {
        this.$set(model, 'shown', !model["shown"]);
      } else {
        this.$set(model, 'shown', true);
      }
    },
    getvidsort(model, skesiftDefault) {
      if (model != null) {
        if (model.selected) {
          model.selected = false;
        } else {
          model.selected = true;
        }
      }

      this.checckdata = [];
      this.groupchecckdata = [];
      var _obj, _arry, arry = [], _selected, _curObj, _isDeviceInfoArray;
      this.groups.forEach(param => {
        _obj = param["group"];
        if (_obj != null) {
          _obj = _obj.forEach(item => {
            if (item.selected == true) {
              _selected = true;
              this.groupchecckdata.push(item);
              _arry = item["DeviceInfos"];
              _arry.forEach(arrayitem => {
                _curObj = arry.find(_item => { return arrayitem["VDeviceId"] == _item["VDeviceId"] && arrayitem["ChildId"] == _item["ChildId"]; });
                if (_curObj == null) {
                  arry.push(arrayitem);
                }
              });
              // }
            }
          });
        }
      });



      this.card_list2.forEach(cardItem => {

        if (_selected == true) {
          _curObj = arry.find(_item => { return _item["ChildId"] == null && cardItem["VDeviceId"] == _item["VDeviceId"] || _item["ChildId"] != null && cardItem["VDeviceId"] == _item["VDeviceId"] && cardItem["ChildId"] == _item["ChildId"]; });

          if (_curObj != null) {
            cardItem["hidden"] = false;
          } else {
            cardItem["hidden"] = true;
            cardItem.ischecked = false;
          }
        } else {
          cardItem["hidden"] = false;
        }
      });

      var _card_list2 = [], __param;

      this.card_list2.forEach(cardItem => {
        if (this.isSearchKeywords) {
          if (this.searchKeywords.indexOf(' ') < 0) {
            const searchKeywords = (this.searchKeywords || '').trim();

            if (
              (cardItem.DeviceName || '').includes(searchKeywords) ||
              (cardItem.ChildName || '').includes(searchKeywords)
            ) {
              cardItem.hidden = false;
            } else {
              cardItem.hidden = true;
              cardItem.ischecked = false;
            }
            // if (
            //   cardItem["DeviceName"].indexOf(searchKeywords) < 0 &&
            //   cardItem["ChildName"].indexOf(searchKeywords) < 0
            // ) {
            //   cardItem["hidden"] = true;
            //   cardItem.ischecked = false;
            // } else {
            //   cardItem["hidden"] = false;
            // }
          } else {
            __param = this.searchKeywords.split(' ').find(_word => {
              const word = (_word || '').trim();
              return cardItem["DeviceName"].indexOf(word) >= 0 || cardItem["ChildName"]?.indexOf(word) >= 0;
            });
            if (__param != null) { cardItem["hidden"] = false; }
            else { cardItem["hidden"] = true; cardItem.ischecked = false; }
          }
        }
        _card_list2.push(cardItem);
        if (cardItem.ischecked) { this.checckdata.push(cardItem); }
      });

      this.card_list2 = _card_list2;

      _obj = null;
      _arry = null;
      arry = null;
      _selected = null;
      __param = null;
      // }
      setTimeout(this.skusiftsort, 100, skesiftDefault);
    },
    //获取当前多区域勾选最顶层区域（用于群组保存 归属）
    getMultipleAreaSelectedTopArea() {
      var d = this.$refs;
      d = d && d["lyTree"];
      d = d && d["_data"];
      d = d && d["treeData"];
      d = d && d[0];

      var item = this.getMultipleAreaSelectedTopAreaInnerBar(d.child, d);
      if (item != null) {
        if (item["data"] != null) {
          this.multipleAreaSelectedTopArea["gpno"] = item["data"]["id"];
          this.multipleAreaSelectedTopArea["name"] = item["data"]["name"];
          this.multipleAreaSelectedTopArea["isOverstep"] = item["isOverstep"];
        } else {
          this.multipleAreaSelectedTopArea["gpno"] = item["id"];
          this.multipleAreaSelectedTopArea["name"] = item["name"];
          this.multipleAreaSelectedTopArea["isOverstep"] = false;
        }
      }
      item = null;
    },
    /**
     * 返回最顶层数据
     * return {"id":,"name"..}树节点数据包
     */
    funMultipleAreaSelectedTopAreaInner(children, item) {
      if (item["switch"] == true) { return item; }
      if (children == null || children.length == 0) { return null; }
      var _result = null, _obj;
      if (children instanceof Array && children.length > 0) {
        children.forEach(param => {
          if (param["switch"] == true) {
            if (_result != null) {
              _result = item;
              return;
            } else {
              _result = param;
            }
          } else if (param["child"] != null && param["child"].length > 0) {
              _obj = this.funMultipleAreaSelectedTopAreaInner(param["child"], param);
              //
              if (_obj != null) {
                if (_result != null) {
                  _result = item;
                  return;
                } else {
                  _result = _obj;
                }
              }
            }
        });
      }
      return _result;
    },
    getMultipleAreaSelectedTopAreaInnerBar(children, item) {
      // if(item["switch"] == true){return item;}
      if (children == null || children.length == 0) { return null; }
      var _result = null, _obj;
      if (children instanceof Array && children.length > 0) {
        children.forEach(param => {
          if (param["switch"] == true) {
            if (_result != null) {
              _result = { "data": item, "isOverstep": true };
              return;
            } else {
              if (param["child"] != null && param["child"].length == 1) {
                _obj = this.getMultipleAreaSelectedTopAreaInnerBar(param["child"], param);
                if (_obj != null) {
                  _result = _obj;
                  return;
                }
              }
              _result = { "data": param, "isOverstep": false };
            }
          } else if (param["child"] != null && param["child"].length > 0) {
              _obj = this.getMultipleAreaSelectedTopAreaInnerBar(param["child"], param);
              if (_obj != null) {
                if (_result != null) {
                  _result = { "data": item, "isOverstep": true };
                  return;
                } else {
                  _result = _obj;
                }
              }
            }
        });
      }
      return _result;
    },
    //判断是否已经存在指定待选池array
    isExist(arry, param, noHiddenAction) {
      var result = null;
      if (arry instanceof Array) {
        result = arry.find(_param => { return _param["VDeviceId"] == param["VDeviceId"] && _param["ChildId"] == param["ChildId"] });
        if (noHiddenAction != true && result != null) { result["hidden"] = false; }
      }
      return result;
    },
    /*
    /* 获得当前区域下的群组
    */
    doGetList(gpno) {

      if (this.is_group != true) {
        //获得当前区域下的群组
        var para = { projectCode: this.$store.state.projectcode, areaNo: gpno != null ? gpno : this.gpno, includeSubArea: true };
        GetList(para, this.functionDoGetLists);
        para = null;
      }
    },
    /* 将设备信息保存到某个群组下面 接口返回数据处理
    * rs:接口返回数据包
    */
    functionDoPost(rs) {
      this.grouploading = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.doGetList();
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 删除群组 接口返回数据处理
    * rs:接口返回数据包
    */
    functionDoDelete(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.doGetList();
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 删除群组
    * item:群组对象
    */
    delgroup(item, indexs, index) {
      this.groups[indexs]["group"].splice(index, 1);
      var para = { projectCode: item.ProjectCode, gpNo: item.GpNo };
      Delete(para, this.functionDoDelete);
      para = null;
    },
    /* 将设备信息保存到某个群组下面
    */
    doPost() {
      var _vid = [];
      this.checckdata.forEach(item => {
        _vid.push({
          "VDeviceId": item["VDeviceId"],
          "ChildId": item["ChildId"]
        });
      });
      _vid = JSON.stringify(_vid);
      var para = {
        ProjectCode: this.$store.state.projectcode,
        AreaNo: this.multipleAreaSelectedTopArea["gpno"],
        AreaName: this.multipleAreaSelectedTopArea["name"],
        Name: this.groupname,
        DeviceInfos: _vid
      };
      this.grouploading = true;
      Post(para, this.functionDoPost);
      para = null;
      _vid = null;
    },
    /* 下拉加载数据
    */
    loadMore(param) {
    },

    /**
     * 过滤必须同一种类型的设备，其余设备禁用展示（isHidenbox）
     * 根据当前已选设备统一计算，避免全选/取消全选后 isHidenbox 未恢复
     * @param {*} list
     */
    getSameDevice(list) {
      if (this.isNeedSameDeviceStatus === 0) return list;

      const checkedDevices = list.filter(device => !!device.ischecked);
      let returnList = list;

      if (checkedDevices.length === 0) {
        returnList = list.map(device => ({
          ...device,
          isHidenbox: false
        }));
      } else {
        const referenceSku = checkedDevices[0].ClassSku;
        returnList = list.map(device => ({
          ...device,
          isHidenbox: device.ClassSku !== referenceSku
        }));
      }

      const sortReturnList = returnList.filter(item => !item.isHidenbox).concat(returnList.filter(item => !!item.isHidenbox));

      return sortReturnList;
      // const notSameItem = lastData.filter(
      //   device => !!device.ischecked &&
      //   device.VDeviceId !== currentDevice.VDeviceId &&
      //   device.ClassSku !== currentDevice.ClassSku
      // );

      // if (!!notSameItem && notSameItem.length) {
      //   lastData.forEach(device => {
      //     if (device.VDeviceId === currentDevice.VDeviceId) {
      //       device.ischecked = false;
      //     }
      //   });
      //   this.debounceMessage('只能选择同类型设备')
      // }
    },
    /* 点击卡片 进行单选或者多选操作
    * list：数据集合
    */
    removeTree(list) {
      const [visibleList, clickedDevice] = list;

      const is_group = this.isDeviceForceRadio === undefined ? this.is_group : this.isDeviceForceRadio;

      if (is_group) {
        //单选：在完整列表上处理，不能用 carddata（搜索后仅为可见子集）
        this.card_list2.forEach(item => {
          if (item.VDeviceId != clickedDevice.VDeviceId) {
            item.ischecked = false;
          } else if (item.ChildId != clickedDevice.ChildId) {
            item.ischecked = false;
          }
        });
        const target = this.card_list2.find(
          item => item.VDeviceId === clickedDevice.VDeviceId && item.ChildId === clickedDevice.ChildId
        );
        if (target) {
          target.ischecked = clickedDevice.ischecked;
        }
      } else if (!this.isScrollRegist && visibleList) {
        // carddata 为浅拷贝时，把勾选状态同步回 card_list2
        visibleList.forEach(visibleItem => {
          const target = this.card_list2.find(
            item => item.VDeviceId === visibleItem.VDeviceId && item.ChildId === visibleItem.ChildId
          );
          if (target) {
            target.ischecked = visibleItem.ischecked;
          }
        });
      }
      // isScrollRegist 为 true 时，勾选已直接写在 card_list2 原对象上

      const lastData = this.getSameDevice(this.card_list2)
      // const [lastData, currentItem] = list;
      // if (currentDevice && this.isNeedSameDevice) {
      //   const ischecked = currentDevice.ischecked;

      //   if (ischecked) {
      //     lastData.forEach(device => {
      //       if (device.ClassSku !== currentDevice.ClassSku) {
      //         device.isHidenbox = true;
      //       } else {
      //         device.isHidenbox = false;
      //       }
      //     })
      //   } else {
      //     const checkLength = lastData.filter(device => !!device.ischecked).length;

      //     if (checkLength === 0) {
      //       lastData.forEach(device => {
      //         device.isHidenbox = false;
      //       })
      //     }
      //   }

        // const notSameItem = lastData.filter(
        //   device => !!device.ischecked &&
        //   device.VDeviceId !== currentDevice.VDeviceId &&
        //   device.ClassSku !== currentDevice.ClassSku
        // );

        // if (!!notSameItem && notSameItem.length) {
        //   lastData.forEach(device => {
        //     if (device.VDeviceId === currentDevice.VDeviceId) {
        //       device.ischecked = false;
        //     }
        //   });
        //   this.debounceMessage('只能选择同类型设备')
        // }
      // }

      // 选中
      //   if (ischecked) {
      //     lastData.forEach(device => {
      //       // 内部逻辑可怕 只能这么加了
      //       device.isdisabled = false;
      //       if (device.VDeviceId !== currentDevice.VDeviceId) {
      //         device.isCheckBoxDisable = device.ClassSku !== currentDevice.ClassSku;
      //       } else {
      //         device.isCheckBoxDisable = false;
      //       }
      //     })
      //   } else {
      //     // 去除
      //     lastData.forEach(device => {
      //       device.isdisabled = false;
      //       device.isCheckBoxDisable = false;
      //     })
      //   }
      // }

      this.card_list2 = lastData;
      this.getCheckedData();
    },
    /* 获得选中的数据
    */
    getCheckedData() {
      //获得选择的数据
      var _arry = [];
      this.card_list2.forEach(item => {
        if (item.ischecked) {
          _arry.push(item);
        }
      });
      this.checckdata = _arry;
      _arry = null;


      // 全选按钮：仅对当前可见（含搜索/类型筛选后）设备
      const visibleTotal = this.getCardTolal();
      this.select = this.checckdata.length === visibleTotal && visibleTotal > 0;

      //选中等于20个设备的时候，提示，（只提示一次）
      let showTips= false
      if(this.checckdata.length == 20 && !this.showTips){
        this.showTips = true
        showTips=true
      }

      if (this.isDataOccupiedLimitGroupDisabled === true) return;

      // 群控：须选中区域内全部可选设备；搜索/类型筛选期间不自动勾选群控
      const hasActiveFilter =
        this.isSearchKeywords ||
        !!(this.searchKeywords && this.searchKeywords.trim()) ||
        (this.skuSiftValue instanceof Array && this.skuSiftValue.length > 0);
      const allSelectableTotal = this.getAllSelectableTotal();
      const allAreaDevicesSelected =
        this.checckdata.length === allSelectableTotal && allSelectableTotal > 0;
      this.$emit('changeGroupPost', allAreaDevicesSelected && !hasActiveFilter, showTips)
    },
    /* 点击树 获得区域下的设备集合
    */
    treeClick(val) {

      if (this.isSwitch == true) { return; }
      //点击左边的树形 回调事件
      if (this.gpno != val[0].id) {
        if (!this.isreplace) {
          this.isScrollRegist = false;
          // socket.emit('sync_info_removeall_event');
          this.pageIndex = 1;
          this.gpno = val[0].id;

          this.doFindDeviceListByPage();
          this.doGetList();
        }
      }
    },
    /**
     * 勾选区域
     */
    switchClickTrue(gpNo) {

      this.addAreaSelectedModel(gpNo);
      this.pageIndex = 1;
      this.doFindDeviceListByPage(); //默认显示全部
      // this.doGetList();
      this.getVideoHeight();
    },
    /**
     * 取消勾选区域
     */
    switchClickFalse(gpNo) {
      this.delAreaSelectedModel(gpNo);

      var _arry = [], _params;
      //消除组集合中此区域
      this.groups.forEach((param, index) => {
        if (param["gpNo"] == gpNo) {

          this.groups.splice(index, 1);
          return;
        }
      });
      this.areamodel.forEach((param, index) => {
        if (param["gpNo"] == gpNo) {

          this.areamodel.splice(index, 1);
          return;
        }
      });
      this.areamodel.forEach(param => {
        _params = param["data"];
        if (_params != null) {
          _params.forEach(_param => {
            if (_arry.indexOf(_param["VDeviceId"]) < 0) { _arry.push(_param["VDeviceId"]); }
          });
        }
      });
      var i = 0;
      for (; i < this.card_list2.length;) {
        _params = this.card_list2[i];
        if (_arry.indexOf(_params["VDeviceId"]) < 0) {
          this.card_list2.splice(i, 1);
          continue;
        }
        i++;
      }
      // i = null;
      this.getvidsort();
    },
    skusiftsort(noDefault) {
      if (noDefault != "noDefault") {
        this.skuSiftValue = [];
        this.skuSiftOptions = [];
        var skuSiftFindObj = null;
        this.card_list2.forEach(item => {
          if (item.hidden != true) {
            skuSiftFindObj = this.skuSiftOptions.find(param => { return param["ClassSku"] === item["ClassSku"]; })
            if (skuSiftFindObj == null) {
              this.skuSiftOptions.push({ "ClassSku": item["ClassSku"], "ClassSkuName": item["ClassSkuName"], "checked": false });
            }
          }
        });
        skuSiftFindObj = null;
      }
      // var d = this.skuSiftValue;
      // var i = 0, l = this.skuSiftValue.length;
      // for(; i< this.skuSiftValue.length;){
      //   skuSiftFindObj = this.skuSiftOptions.find( param=>{return param["ClassSku"] === this.skuSiftValue[i];})
      //   if(skuSiftFindObj == null){
      //     this.skuSiftValue.splice(i,1);
      //     continue;
      //   }
      //   i++;
      // }
      if (this.skuSiftValue instanceof Array && this.skuSiftValue.length > 0) {
        var _card_list2 = [];
        this.card_list2.forEach(item => {
          _card_list2.push(item);
          if (item.hidden != true) {
            skuSiftFindObj = this.skuSiftValue.find(param => { return param["ClassSku"] === item["ClassSku"]; });
            if (skuSiftFindObj == null) {
              item["hidden"] = true;
              item.ischecked = false;
            }
          }
        });
        this.card_list2 = _card_list2;
        this.getCheckedData();
      }
    },
    skusiftsortEvent(autoAction) {
      if (autoAction == 'skuSiftValue') {
        this.skuSiftValue = [];
        this.skuSiftOptions.forEach(item => {
          if (item["checked"] == true) {
            this.skuSiftValue.push(item);
          }
        });
      } else if (autoAction == "skuSiftOptions") {
        var obj;
        this.skuSiftOptions.forEach(item => {
          obj = this.skuSiftValue.find(param => { return param["ClassSku"] === item["ClassSku"]; });
          if (obj != null) {
            item["checked"] = true;
          } else {
            item["checked"] = false;
          }
        });
      }
      if (this.searchKeywords && this.searchKeywords.trim()) {
        this.isSearchKeywords = true;
      }
      this.getvidsort(null, "noDefault");
    },

    getGpNosByTreeNode(nodes, gpNos = []) {
      nodes.forEach(item => {
        if (item.switch) {
          gpNos.push(item.id)
        } else {
          if (Array.isArray(item.child)) {
            this.getGpNosByTreeNode(item.child, gpNos)
          }
        }
      })
    },

    /* 点击树 获得区域下的设备集合
    */
    switchClick(val) {
      var checkedKeys = val[4];
      checkedKeys = checkedKeys && checkedKeys["checkedKeys"];
      var halfCheckedKeys = val[4];
      halfCheckedKeys = halfCheckedKeys && halfCheckedKeys["halfCheckedKeys"];
      this.curHalfCheckedArea = halfCheckedKeys;

      this.gpno = val[0].id;

      const gpNos = [];

      const allNode = this.$refs.lyTree.treeData;

      this.getGpNosByTreeNode(allNode, gpNos);

      this.gpNos = gpNos;
// console.log('gpNos', gpNos);



      // if (val[3]) {
      //   this.gpNos.push(val[0].id)
      // } else {
      //   this.gpNos.filter(id => id !== val[0].id)
      // }

      if (val[3] == true) {
        // this.addAreaSelectedModel(val[0].id);
        // this.pageIndex = 1;
        // this.doFindDeviceListByPage(); //默认显示全部
        // this.doGetList();
        // this.getVideoHeight();
        this.switchClickTrue(val[0].id);

        //增加缓存数据池 - 勾选区域 -Star
        if (checkedKeys instanceof Array && checkedKeys.length > 0) {
          this.autoAddCheckedArea(checkedKeys);
          this.doGetList(this.gpno);
        }
        //增加缓存数据池 - 勾选区域 -End

      } else {
        this.switchClickFalse(val[0].id);

        // //清理缓存数据池 - 半勾选区域 -Star
        if (halfCheckedKeys instanceof Array && halfCheckedKeys.length > 0) {
          this.autoClearHalfCheckedArea(halfCheckedKeys);
        }

        this.autoClearMinusUncheckedArea(this.areaSelectedModel, checkedKeys);
        //清理缓存数据池 - 半勾选区域 -End
        this.doFindDeviceListByPage();
        this.getVideoHeight();
      }
      this.getMultipleAreaSelectedTopArea();
      checkedKeys = null;
      halfCheckedKeys = null;
    },
    /**
     * 返回监听勾选节点区域
     */
    getCheckedKeys(_Gpnos) {
      this.autoAddCheckedArea(_Gpnos);
    },
    /**
     * 清理缓存数据池 - 差集
     */
    autoClearMinusUncheckedArea(arrayA, arrayB) {
      var _Gpnos = arrayA.minus(arrayB); //缓存池中 还存在 未勾选的区域
      _Gpnos.forEach(gpNo => {
        this.switchClickFalse(gpNo);
      });
      _Gpnos = null;
    },
    /**
     * 清理缓存数据池 - 半勾选区域
     */
    autoClearHalfCheckedArea(_Gpnos) {
      if (_Gpnos instanceof Array && _Gpnos.length > 0) {
        // var _GpnosIndex;
        _Gpnos.forEach(gpNo => {
          this.switchClickFalse(gpNo);
        });
      }
    },
    /**
     * 新增缓存数据池 - 勾选区域
     */
    autoAddCheckedArea(_Gpnos) {
      if (_Gpnos instanceof Array && _Gpnos.length > 0) {
        _Gpnos.forEach(gpNo => {
          this.autoDeviceInAreaModelFun(gpNo);
        });
      }
    },
    autoDeviceInAreaModel(itemArray) {
      if (itemArray == null) { return; }
      var _ParentGpnos;
      itemArray.forEach(device => {
        if (device["Gpno"] != null) {
          if (typeof device["ParentGpnos"] == "string") {//会归入父级所涉及区域
            _ParentGpnos = device["ParentGpnos"];
            _ParentGpnos = _ParentGpnos.replace(/@/g, '');
            _ParentGpnos = _ParentGpnos.split(',');
            if (_ParentGpnos instanceof Array && _ParentGpnos.length > 0) {
              _ParentGpnos.forEach(Gpno => {
                this.autoDeviceInAreaModelFun(Number(Gpno), device);
              });
            }
          } else {//会归入房间区域
            this.autoDeviceInAreaModelFun(device["Gpno"], device);
          }
        }
      });
      _ParentGpnos = null;

    },

    /**
     * 内函数：被autoDeviceInAreaModel调用
     */
    autoDeviceInAreaModelFun(gpNo, item, _nocreat) {
      // if(gpNo == "4294901761"){}
      if (item != null && this.curHalfCheckedArea != null && this.curHalfCheckedArea.indexOf(gpNo) >= 0) { return; }
      if (this.areaSelectedModel.indexOf(gpNo) < 0) {
        this.addAreaSelectedModel(gpNo);
        // this.doGetList(gpNo);
      }
      var _areamodel = this.areamodel.find(_param => {
        return _param["gpNo"] == gpNo;
      });
      if (_areamodel == null) {
        _areamodel = { gpNo: gpNo, data: [] };
        if (item != null) {
          _areamodel["data"].push(item);
        }
        this.areamodel.push(_areamodel);
      } else if (item != null) {
          if (this.isExist(_areamodel["data"], item) == null) {
            _areamodel["data"].push(item);
          }
        }
      _areamodel = null;
    },
    /* 获得设备卡信息 接口返回数据处理
    * rs：接口返回数据包
    * params：查询参数
    */
    functionDoFindTriggerList(rs, params) {
      if (this.isNeedSameDeviceStatus !== 0) {
        setTimeout(() => {
          this.loading = false;
        }, 50)
      } else {
        this.loading = false;
      }

      this.dropdownloading = false;

      if (
        this.isSwitch == true &&
        this.areaSelectedModel.filter(
          item => ((`${params.gpNos}` || '').split(',') || [params.gpNo]).includes(`${item}`)).length === 0 && // 判断是否有交集
        // this.areaSelectedModel.indexOf(params["gpNo"]) < 0 &&
        !this.getDeviceListFn
      ) { return; }//判断区域未勾选上，数据不累加
      //triggle跟action设备的查询结果处理

      let recordList = rs.Result?.RecordList || [];

      console.log(recordList)

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.autoDeviceInAreaModel(recordList);

        /* 排除对应SKU设备 */
        if(this.executeClassSku.length > 0){
          recordList = recordList.filter(item=> {
            return this.executeClassSku.indexOf(item.ClassSku) === -1
          })
        }


        if(this.onlyClassSku.length > 0){
          recordList = recordList.filter(item=> {
            return this.onlyClassSku.indexOf(item.ClassSku) !== -1
          })
        }

        if (this.isSwitch == true) {
          if (this.card_list2 == null) { this.card_list2 = []; }
        } else if (params.pageIndex == null || params.pageIndex == 1) {
            this.card_list2 = [];
            //需要知道总记录条数  单选也需要注册 临时解决方案

            if(!this.singleChoiceRegister){
              this.isScrollRegist = true;
            }

          }

        this.card_list2Source = this.card_list2Source || { gpNo: '', data: [] };
        if (this.card_list2Source["gpNo"] != params["gpNo"]) {
          this.card_list2Source = { gpNo: params["gpNo"], data: [] };
        }
        var _areamodel = this.areamodel.find(_param => {
          return _param["gpNo"] == params["gpNo"];
        });
        if (_areamodel == null) {
          this.areamodel.push(this.card_list2Source);
        } else {
          _areamodel["data"] = this.card_list2Source["data"];
        }
        _areamodel = null;
        // if (rs.Result && recordList.length > 0
        //   || rs.Result && rs.Result.length > 0
        // ) {
        if (rs.Result && Array.isArray(recordList) || Array.isArray(rs.Result)) {
          // if((rs.Result && rs.Result["TotalCount"]>0 && rs.Result.RecordList != null  && rs.Result.RecordList.length>0)
          //     ||(rs.Result && rs.Result.length > 0)
          //   ){

          /*if (rs.Result.RecordList != null) {
            this.sortResult("device", rs.Result, "RecordList");
          } else if (rs.Result) {
            this.sortResult("device", rs, "Result");
          }*/
          this.RecordList = recordList || rs.Result;
          if (this.isOccupiedLimitGroup == true) { this.isDataOccupiedLimitGroup = false; }
          this.card_list2 = [];
          (recordList || rs.Result).forEach(item => {
            // var _d = this.isOccupiedLimitGroup;
            // var _t = this.isDataOccupiedLimitGroup;

            //规则 当前用于 恒照度/节律 - 开始
            if (this.isOccupied == true) {
              if (this.curRuleId != null) { //修改模式
                if (this.isOccupiedLimitGroup == true) {
                  if (this.isCurRuleGroup == true) {
                    // if(item["IsOccupied"] == this.isOccupied &&
                    //   typeof item["OccupiedValues"] != "undefined" &&
                    //   item["OccupiedValues"] != null &&
                    //   item["OccupiedValues"].length > 1 &&
                    //   item["OccupiedValues"].indexOf(this.curRuleId) >= 0
                    // ){
                    //   return; //隐藏// return;
                    // }
                  } else if (item["IsOccupied"] == this.isOccupied) {
                      if (this.isOccupiedLimitGroup == true) {
                        this.isDataOccupiedLimitGroupDisabled = true;
                        // this.occupiedList.push(item);
                        // this.isDataOccupiedLimitGroup = true;
                      }
                      return; //隐藏// return;
                    }
                }
              } else {//新建模式
                if (item["IsOccupied"] == this.isOccupied) {
                  console.log('jinlai2');
                  if (this.isOccupiedLimitGroup == true) {
                    this.isDataOccupiedLimitGroupDisabled = true;
                    this.occupiedList.push(item);
                    // this.isDataOccupiedLimitGroup = true;
                  }
                  return; //隐藏// return;
                }
              }
            }
            // console.log('jinlai3');
            item.ischecked = false;

            var isdel = false;
            if (this.isCompare && this.alreadychecked != null) {//areaTreeType == 2) {
              for (let i = 0; i < this.alreadychecked.length; i++) {
                if (item.VDeviceId == this.alreadychecked[i].VDeviceId && (item.ChildId == this.alreadychecked[i].ChildId || item.ChildId == this.alreadychecked[i].ChannelId)) {
                  isdel = true;
                  if (this.isShowCheck == true) { item.ischecked = true; }
                }
              }
            }
            //只比较VDeviceId,一样的话就过滤
            if(this.onlyCompareDevice && this.alreadychecked != null){
              for (let i = 0; i < this.alreadychecked.length; i++) {
                if (item.VDeviceId == this.alreadychecked[i].VDeviceId) {
                  isdel = true;
                }
              }
            }
            if (this.triggledevice && this.alreadychecked != null) {
              for (let i = 0; i < this.alreadychecked.length; i++) {
                if (item.VDeviceId == this.alreadychecked[i].VDeviceId) {
                  item.havecheck = true;
                  if (this.isShowCheck == true) { item.ischecked = true; }
                }
              }
            }

            if (this.actionedevice && this.alreadychecked != null) {
              for (let i = 0; i < this.alreadychecked.length; i++) {
                if (this.alreadychecked[i].ActionType == 0) {
                  if (item.VDeviceId == this.alreadychecked[i].VDeviceId && item.ChildId == this.alreadychecked[i].ChannelId) {
                    item.havecheck = true;
                    if (this.isShowCheck == true) { item.ischecked = true; }
                  }
                }
              }
            }
            //multipleDialogGroup 增加自动化判断,不过滤设备
            if (!isdel || this.isShowCheck == true || this.multipleDialogGroup) {


              item.flag = false; //是否可编辑
              if (this.isShowCheck != true) {
                item.ischecked = false; //是否默认选中
              }
              // item.isflicker = false; //是否闪烁
              this.$set(item, 'isflicker', false);
              item.isdisabled = false; //是否禁用
              item.hidden = false; //是否隐藏

              // 增加设备卡片上已选字段
              console.log('.....增加设备卡片上已选字段')
              if(isdel && this.multipleDialogGroup){
                item.multipleDialogGroup = true;
              }
              if (item.StatusInfo) {
                if (item.StatusInfo != null && item.StatusInfo != '') {
                  item.StatusInfo = JSON.parse(item.StatusInfo);
                } else {
                  item.StatusInfo = [];
                }
              }
              if (this.ispannel) {
                if (item.ClassSku == "0x02000301" || item.ClassSku == "0x02000306" || item.ClassSku == "0x00193005" || item.ClassSku == "0x00193006" || item.ClassSku == "0x00193007" || item.ClassSku == "0x00153005" || item.ClassSku == "0x00153006" || item.ClassSku == "0x00153007" || item.ClassSku == "0x001F0003" || item.ClassSku == "0x02000311") {
                  if (1/*this.isExist(this.card_list2, item) == null*/) {
                    this.card_list2.push(item);
                  }
                  this.card_list2Source["data"].push(item);
                }
              } else {
                if (1/*this.isExist(this.card_list2, item) == null*/) {
                  this.card_list2.push(item);
                }
                this.card_list2Source["data"].push(item);
              }
            }
            isdel = null;
          });
          if (rs.Result && rs.Result["TotalCount"] > 0 && recordList.length > 0 && this.card_list2.length == 0) {
            this.loadMore();
          }
        }

        // if (this.occupiedList.length > 0 && this.is_groupControlDisabled && this.pageType !== 'edit') {
        //   this.isDeviceTableModalVisible = true;
        // }

        // if (this.occupiedList.length === 0 && this.is_groupControlDisabled && this.pageType !== 'edit') {
        //   this.groupControlValue = true;
        //   this.groupControlValueDisabled = true;
        //   this.$emit('groupControlEvent', true);
        // }
      } else {
        this.card_list2 = [];
        this.card_list2Source = null
      }
      // this.loading = false;
      // this.dropdownloading = false;
      if (params.pageIndex == null || params.pageIndex == 1) {
        this.registerList = this.card_list2;
      }
      if (this.card_list2.length > 0 && this.card_list2.length < rs.Result.TotalCount) {
        // if (this.alreadychecked.length > 0) {
        // this.isdropdown = true;
        // } else {
        this.isdropdown = false;
        // }
      }
      if (this.card_list2.length > 0) {
        this.$store.dispatch('changeIsregisterSocket', true);
      }
      // else{
      // 	socket.emit('sync_info_removeall_event');
      // }
      this.allCard();
      this.isshow = true;
    },
    /* 获得可绑定设备的 接口返回数据处理
    * rs：接口返回数据包
    * params：查询参数
    */
    functionDoGetCanBindList(rs, params) {
      // console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (params.pageIndex == null || params.pageIndex == 1) {
          this.card_list2 = [];
          this.card_list2Source = [];
          //需要知道总记录条数
          this.isScrollRegist = true;
        }
        if (rs.Result) {
          if (rs.Result.length > 0) {

            rs.Result.forEach(item => {
              item.flag = false; //是否可编辑
              item.ischecked = false; //是否默认选中

              // item.isflicker = false; //是否闪烁

              this.$set(item, 'isflicker', false);
              item.isdisabled = false; //是否禁用

              if (item.StatusInfo) {
                if (item.StatusInfo != null && item.StatusInfo != "") {
                  item.StatusInfo = JSON.parse(item.StatusInfo);
                } else {
                  item.StatusInfo = [];
                }
              }

              this.card_list2.push(item);
              this.card_list2Source.push(item);

            });

          }

        } else {
          this.card_list2 = [];
          this.card_list2Source = [];
        }

      } else {
        this.card_list2 = [];
        this.card_list2Source = [];
      }
      if (params.pageIndex == null || params.pageIndex == 1) {
        this.registerList = this.card_list2;
      }
      if (this.card_list2.length > 0) {
        this.$store.dispatch('changeIsregisterSocket', true);
      }
      // else{
      // 	socket.emit('sync_info_removeall_event');
      // }
      this.loading = false;

      this.allCard();
      this.isshow = true;
    },
    /* 获得设备-配网查询的网关设备 接口返回数据处理
    * rs：接口返回数据包
    * params：查询参数
    */
    functionDoFindDeviceListByPage(rs, params) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (params.pageIndex == null || params.pageIndex == 1) {
          this.card_list2 = [];
          this.card_list2Source = [];
          //需要知道总记录条数
          this.isScrollRegist = true;
        }
        if (rs.Result != null && rs.Result.RecordList != null) {
          rs.Result.RecordList.forEach(item => {
            var isdel = false;

            for (let i = 0; i < this.alreadychecked.length; i++) {
              if (item.VDeviceId == this.alreadychecked[i].VDeviceId && item.ChildId == this.alreadychecked[i].ChildId) {
                isdel = true;
              }
            }
            if (!isdel) {
              item.flag = false; //是否可编辑
              item.ischecked = false; //是否默认选中

              // item.isflicker = false; //是否闪烁

              this.$set(item, 'isflicker', false);
              item.isdisabled = false; //是否禁用

              item.hidden = false; //是否隐藏

              if (item.StatusInfo) {
                if (item.StatusInfo != null && item.StatusInfo != '') {
                  item.StatusInfo = JSON.parse(item.StatusInfo);
                } else {
                  item.StatusInfo = [];
                }
              }

              this.card_list2.push(item);
              this.card_list2Source.push(item);
            }
            isdel = null;
          });
        }

      } else {
        this.card_list2 = [];
        this.card_list2Source = [];
      }
      this.loading = false;
      if (params.pageIndex == null || params.pageIndex == 1) {
        this.registerList = this.card_list2;
      }
      this.dropdownloading = false;
      if (this.card_list2.length > 0 && this.card_list2.length < rs.Result.TotalCount) {
        // if (this.alreadychecked.length > 0) {
        // this.isdropdown = true;
        // } else {
        this.isdropdown = false;
        // }
      }
      if (this.card_list2.length > 0) {
        this.$store.dispatch('changeIsregisterSocket', true);
      }
      // else{
      // 	socket.emit('sync_info_removeall_event');
      // }
      this.allCard();
      this.isshow = true;
    },
    /* 获得设备-配网查询的网关设备 接口返回数据处理
    * rs：接口返回数据包
    * params：查询参数
    */
    async doFindDeviceListByPage(byChecked) {
      if (byChecked != true) { this.CheckedData = []; }
      if (!this.dropdownloading) {
        this.loading = true;
      }
      this.isdropdown = true;
      this.isshow = false;
      // var para = null;
      var para = {};

      // 添加联动面板情况下的入参 gatewayVDeviceId 网关设备id
      if(this.gatewayVDeviceId) para.gatewayVDeviceId = this.gatewayVDeviceId

      const gpNos = this.gpNos ? this.gpNos.join(',') : this.gpno;

      if (this.getDeviceListFn) {
        await this.getDeviceListFn({gpNos: gpNos},this.functionDoFindTriggerList);
        this.loading = false;

        return;
      }



      if (!this.isreplace) {
        if (this.areaTreeType == 1 && this.exendProtocolTypes == 16) {
          //传感器选择 不分页
          para = { gpNos: gpNos, ...para };
          // para["extendDeviceTypes"] = 16;
          para["childCategoryType"] = 128;
          para["gpNo"] = this.gpno;
          if (this.requiredMessageType) {
              para.requiredMessageType =  this.requiredMessageType
            }
          if (this.postFunParam != null) { para = this.extend(para, this.postFunParam); }
          if (this.childCategoryType != null && para["childCategoryType"] == undefined) { para["childCategoryType"] = this.childCategoryType; }
          if (this.classSkus) para.classSkus = this.classSkus;
          if (this.deviceCategoryType) { para.deviceCategoryType = this.deviceCategoryType; }
          await this.postFunction(para, this.functionDoFindTriggerList);
        } else if (this.areaTreeType == 1 && this.executeType == 1) {
          para = { gpNos: gpNos, pageIndex: this.pageIndex, pageSize: this.pageSize, ...para };
          para["executeType"] = 1;
          // para["deviceType"] = 3;
          para["gpNo"] = this.gpno;

          if (this.requiredMessageType) {
              para.requiredMessageType =  this.requiredMessageType
            }

          if (this.postFunParam != null) { para = this.extend(para, this.postFunParam); }
          if (this.childCategoryType != null && para["childCategoryType"] == undefined) { para["childCategoryType"] = this.childCategoryType; }
          if (this.classSkus) para.classSkus = this.classSkus;
          if (this.deviceCategoryType) { para.deviceCategoryType = this.deviceCategoryType; }
          await this.postFunction(para, this.functionDoFindTriggerList);
        } else if (this.areaTreeType == 1 && this.executeType == 2) {
          para = { gpNos: gpNos, pageIndex: this.pageIndex, pageSize: this.pageSize, ...para };
          para["executeType"] = 2;  //1是匹配trigger的，2是匹配action的

          para.showMode = 1

          if (this.requiredMessageType) {
              para.requiredMessageType =  this.requiredMessageType
            }

          console.log('this.classSkus', this.classSkus);

          if (this.classSkus) para.classSkus = this.classSkus;

          try {
            if(this.isSence){
              para.showMode = 2
            }
          } catch (error) {

          }
          try {
            if(this.isIfttt){
            para.showMode = 4
          }
          } catch (error) {

          }

          para["gpNo"] = this.gpno;
          if (this.postFunParam != null) { para = this.extend(para, this.postFunParam); }
          if (this.childCategoryType != null && para["childCategoryType"] == undefined) { para["childCategoryType"] = this.childCategoryType; }
          if (this.deviceCategoryType) { para.deviceCategoryType = this.deviceCategoryType; }
          const bindStatus = this.isHcl ? 1 : this.bindStatus;
          if (bindStatus !== -1) {
            para.bindStatus = bindStatus;
          }
          await this.postFunction(para, this.functionDoFindTriggerList);
        } else if (this.areaTreeType == 1) {
          //设备
          if (!this.triggledevice && !this.actionedevice) {
            para = { gpNos: gpNos, pageIndex: this.pageIndex, pageSize: this.pageSize, ...para };

            if (this.requiredMessageType) {
              para.requiredMessageType =  this.requiredMessageType
            }

            if (this.searchtype == 1) {
              //真实网关
              // para.deviceType = 1;
              para["childCategoryType"] = 1;
              para.bindStatus = 1;
            } else if (this.searchtype == 0) {
              //虚拟网关
              // para.deviceType = 1;
              para["childCategoryType"] = 1;
              para.bindStatus = -1;
            }
            para["gpNo"] = this.gpno;
            if (this.postFunParam != null) { para = this.extend(para, this.postFunParam); }
            if (this.childCategoryType != null && para["childCategoryType"] == undefined) { para["childCategoryType"] = this.childCategoryType; }
            if (this.classSkus) para.classSkus = this.classSkus;
            if (this.deviceCategoryType) { para.deviceCategoryType = this.deviceCategoryType; }
            await this.postFunction(para, this.functionDoFindTriggerList);
          } else {
            para = { gpNos: gpNos, pageIndex: this.pageIndex, pageSize: this.pageSize, ...para };
            if (this.triggledevice) {
              //triggle设备选择(自动化)
              para["executeType"] = 1;
              // para["deviceType"] = 3;
              para["gpNo"] = this.gpno;
              if (this.postFunParam != null) { para = this.extend(para, this.postFunParam); }
              if (this.childCategoryType != null && para["childCategoryType"] == undefined) { para["childCategoryType"] = this.childCategoryType; }
              if (this.classSkus) para.classSkus = this.classSkus;
              if (this.deviceCategoryType) { para.deviceCategoryType = this.deviceCategoryType; }
              await this.postFunction(para, this.functionDoFindTriggerList);
            }
            if (this.actionedevice) {
              //action设备选择(自动化)
              para["executeType"] = 2;
              // para["deviceType"] = 2;
              para["gpNo"] = this.gpno;
              if (this.postFunParam != null) { para = this.extend(para, this.postFunParam); }
              if (this.childCategoryType != null && para["childCategoryType"] == undefined) { para["childCategoryType"] = this.childCategoryType; }
              if (this.classSkus) para.classSkus = this.classSkus;
              if (this.deviceCategoryType) { para.deviceCategoryType = this.deviceCategoryType; }
              await this.postFunction(para, this.functionDoFindTriggerList);
            }
          }
        }
      } else {
        para = { vDeviceId: this.gpno, pageIndex: this.pageIndex, pageSize: this.pageSize, ...para };
        GetCanBindListByPage(para, this.functionDoGetCanBindList);
      }
      para = null;
    },
    /* 获得查询设备数量
    */
    allCard() {
      this.allcardNum = this.card_list2.length;
      setTimeout(this.skusiftsort, 100);
      setTimeout(this.skusiftsortEvent, 100);
    },
    getCardTolal() {
      var num = 0;
      this.card_list2.forEach(item => {
        if (item.hidden != true) {
          num++;
        }
      })
      return num;
    },
    /** 当前区域下全部可选设备数（不受搜索/类型筛选 hidden 影响），用于判断是否应自动勾选群控 */
    getAllSelectableTotal() {
      let num = 0;
      this.card_list2.forEach(item => {
        if (!item.isdisabled) {
          num++;
        }
      });
      return num;
    },
    checkboxSelect(index, event) {
      var onlyCheck = this.$data.card_list2[index].checked;
    },
    /* 点击确定 给调用的页面返回已选中的设备
    */
    createGrop() {
      //将body上有一个clas叫v-modal的元素去掉
      var body = document.getElementsByTagName('body')[0];
      var modal = document.getElementsByClassName('v-modal')[0];
      if (modal &&  modal.parentNode === body) {
        body.removeChild(modal);
      } else {
        console.warn('Modal is not a child of body or does not exist.');
      }
      console.log('......this.hasSelectDevice',this.hasSelectDevice)
      if(this.requiredMaxDevice && this.checckdata.length > (this.maxDevice-this.hasSelectDevice)){
        warning(this, this.$t('adddevice.addMaxDeviceTitle').replace('{{max}}', this.maxDevice));
        return;
      }
      if (this.isConfirmcCalibrate == true) {
        if (this.checckdata.length > 0) {
          this.$emit('confirm', this.checckdata, this.groupchecckdata);
        } else {
          warning(this, this.$t('deviceChoose.checkwarning'));
        }
      } else {
        this.$emit('confirm', this.checckdata, this.groupchecckdata);
      }
    },
    /* 编辑群组名称
    */
    editGroupName(item, indexs, index) {
      if (item.edit_group) {
        item.edit_group = false;
        this.groups[indexs]["group"][index] = item;
      } else {
        this.doUpdateName(item, indexs, index);
      }
    },
    /* 全选
    */
    checkAll(e) {
      if (e) {
        this.select = true;
      } else {
        this.select = false;
      }
      this.selectCheckBox(e);
      // this.$emit('groupControlEvent', this.select)
    },
    /* 执行全选操作
    */
    selectCheckBox(_flag) {
      this.card_list2.forEach(cardItem => {
        if (cardItem.hidden != true && !cardItem.isdisabled) {
          cardItem.ischecked = _flag; //全选 / 取消全选
        }
      });

      if (this.isNeedSameDeviceStatus !== 0) {
        this.card_list2 = this.getSameDevice(this.card_list2);
        if (_flag) {
          this.card_list2.forEach(cardItem => {
            if (cardItem.isHidenbox) {
              cardItem.ischecked = false;
            }
          });
          this.card_list2 = this.getSameDevice(this.card_list2);
        }
      }

      this.getCheckedData();
    },
    /* 捕捉滚轴滚动事件
    */
    scrollEvent(e) {
      this.scrollEventFunParam = e;
      if (this.scrollEventTime != null) {
        clearTimeout(this.scrollEventTime);
      }
      this.scrollEventTime = setTimeout(this.scrollEventDo, 1000, e);
    },
    /* 核算当前可见区域的设备
    *
    */
    scrollEventDo(_param) { //核算当前可见区域的设备-返回数组
      const that = this;
      this.isScrollRegist = true;
      var param = _param || this.scrollEventFunParam;
      this.registerList = this.scrollEventDoShowCardList(param, this.card_list2);
    }
  }
}
</script>
<style lang="scss" scoped>
.button-light {
  display:inline-block;
  width: 103px;
  padding: 0 5px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #0046aa;
  border-radius: 2px;
  color: #0046aa;
  margin-left: 10px;
  cursor: pointer;
  white-space: nowrap;  /* 保持文本在一行内显示 */
  overflow: hidden;     /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}
</style>

<style>
.optionObj-height {
  max-height: 300px;
  overflow: auto;
}
/* 设备选择弹窗组件 */
.groupchecked {
  width: 23px;
  height: 18px;
  background-position: 50% center;
  background-image: url('~@static/img/checkboxNo.png');
  background-repeat: no-repeat;
  float: right;
  margin-right: 33px;
  margin-top: 8px;
}
.edit_group_span {
  width: 165px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.dialogGroup_right.slidexport {
  width: calc(100% - 70px) !important;
}
.dialogGroup_right_hideTree{
  width: 100% !important;
}
.slidPoint {
  background-image: url(../../assets/img/dingwei.png);
  background-repeat: no-repeat;
  background-size: 15px;
  font-size: 12px;
  padding-left: 20px;
  margin: 5px;
  margin-left: 12px;
  line-height: 15px;
  height: 15px;
  margin-top: 13px;
}
.fox{
  width: 98%;
}
</style>
